module.exports = __webpack_public_path__ + "static/hero-house-2400w-3d9162f6122b2396a9e58694b38becdd.jpg";